import { CONFIG } from '../config/config';
import { apiFetch } from '../utils/apiFetch';
import { mklog } from '../utils/debug';

const log = mklog('SHEET');
const API_URL = (CONFIG?.API_URL || '/api').replace(/\/+$/, '');

export function normalizeCodes(s) {
  return String(s || '')
    .toUpperCase()
    .replace(/["'\s]/g, '')
    .replace(/\++/g, '+')
    .replace(/^\+|\+$/g, '');
}

export function normalizeSheetPayload(data) {
  if (!data) return null;
  const raw = data?.raw ?? data;
  const table = Array.isArray(raw?.table) ? raw.table : [];
  const updatedAt = raw?.updatedAt ?? data?.updatedAt ?? null;
  return {
    table,
    updatedAt,
    banner: data?.banner ?? raw.message ?? raw.text ?? null,
    version: data?.version ?? raw.version ?? null,
    raw: data?.raw ?? data,
  };
}

export function domainOf(p) {
  const raw = (p?.domaine || p?.cotationDomaine || p?.cotation_json?.domaine || '')
    .toString()
    .toUpperCase();
  return raw.startsWith('TRAUMA') ? 'traumato' : 'medecine';
}

/**
 * LANCE la synchro Google Sheet côté back et renvoie l'état courant.
 */
export async function sheetGet(passageId, token) {
  log('GET sheet', { passageId });
  const r = await apiFetch(`/api/cotation/passages/${passageId}/cotation/sheet`, {
    headers: token ? { Authorization: `Bearer ${token}` } : undefined,
  });
  if (!r.ok) throw new Error(`HTTP ${r.status}`);
  const data = await (r.json?.() ?? r);
  log('GET sheet -> ok', {
    rows: Array.isArray(data?.raw?.table) ? data.raw.table.length : data?.table?.length || 0,
    updatedAt: data?.updatedAt || data?.raw?.updatedAt || null,
  });
  return normalizeSheetPayload(data);
}

export async function sheetSyncAndPoll({
  passageId,
  codes,
  token,
  domain = 'traumato',
  musiqId,
  isDemo,
  resQualif,
  useScriptTestApi = false,
}) {
  const normalized = normalizeCodes(codes);
  log('POST resync', { passageId, codes: normalized, resQualif });

  // Si le router Express est monté sur /api/cotation :
  const res = await apiFetch(`/api/cotation/passages/${passageId}/cotation/sheet/resync`, {
    method: 'POST',
    headers: token ? { Authorization: `Bearer ${token}` } : undefined,
    body: JSON.stringify({
      codes: normalized,
      domain,
      musiqId,
      isDemo,
      resQualif,
      useScriptTestApi: Boolean(useScriptTestApi),
    }),
  });

 if (!res.ok) throw new Error(`HTTP ${res.status}`);

  const data = await res.json();

  // La route resync renvoie directement { ok: true, sheet: { table, raw, ... } }
  if (data?.sheet?.table?.length) {
    return normalizeSheetPayload(data.sheet);
  }

  // Fallback si jamais la sheet n'était pas dans la réponse directe
  return sheetGet(passageId, token);
}

export async function getAllActes() {
  const res = await apiFetch('/api/cotation/all-actes', { method: 'GET' });
  if (!res.ok) throw new Error('Impossible de charger la configuration');
  return res.json();
}